import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/panel.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import '@flixbus/honeycomb-icons-react';
import '../../../packages/props-utils/prop-types.js';

const bemPanel = new HoneyBem('panel', styles);
function PanelFooterColumn(_a) {
  var {
      children,
      narrow = false,
      extraClasses
    } = _a,
    rest = __rest(_a, ["children", "narrow", "extraClasses"]);
  return /*#__PURE__*/React.createElement("div", Object.assign({}, rest, {
    className: bemPanel.e('footer-column', {
      narrow
    }, extraClasses)
  }), children);
}
PanelFooterColumn.displayName = 'PanelFooterColumn';
PanelFooterColumn.propTypes = {
  extraClasses: PropTypes.string,
  children: PropTypes.node.isRequired,
  narrow: PropTypes.bool
};

export { PanelFooterColumn as default };
